module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOTM3ODY2NmE3ZGEyN2VlZDY3ZjEwZGZlNGQxYWMwZTgucG5nIjs="